import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const purchaseWithPurchaseAddRolesRBAC = {
  pageID: '5071e0322503b2081398126341c0a4ae',
  elementID: {
    SubmitAddButton: '3938097d8c332e2925404b736fbe4850',
    ButtonUploadSekaligus: '2ac81da9f8cbc1eb01bff30188e715ef',
    ButtonPilihProduk: '08a67b59801e8e24d30886a260d6ee95',
  },
} as const

export const useRBACPurchaseWithPurchaseAddPage = createUseRBAC(
  purchaseWithPurchaseAddRolesRBAC.elementID,
)

export type UseRBACPurchaseWithPurchaseAddPageType = ReturnType<
  typeof useRBACPurchaseWithPurchaseAddPage
>

export const purchaseWithPurchaseEditRolesRBAC = {
  pageID: '2b2e6b0fb84ff78c120b3630f0698ba2',
  elementID: {
    ViewPage: 'd2cba8092262d5149dd97e64b8fae694',
    SubmitEditButton: '5e06f03a98c9d18d23c0d0272acfbbdc',
    ButtonUploadSekaligus: '5ec6952e2ad7581f1fa3a6ba933013a3',
    ButtonPilihProduk: '1a888502fc122fabb8334f8552b44e29',
  },
} as const

export const useRBACPurchaseWithPurchaseEditPage = createUseRBAC(
  purchaseWithPurchaseEditRolesRBAC.elementID,
)

export type UseRBACPurchaseWithPurchaseEditPageType = ReturnType<
  typeof useRBACPurchaseWithPurchaseEditPage
>
